
import request from '@/utils/request'

// 广告相关接口
export const adApi = {
  // 获取首页广告
  getHomeAds() {
    return request.get('/ads/home', null, { noLoading: true })
  },
  // 获取广告分类列表 -  暂时用不到
  getAdsCategorys() {
    return request.get('/ad-category/list', null, { noLoading: true })
  },
  // 获取分类广告
  getCategoryAd(category, params) {
    return request.get(`/ads/${category}`, params)
  },
  // 记录广告点击
  updateAdClick(id) {
    return request.patch(`/ads/click/${id}` , {} , { noLoading: true })
  },
}

// 用户相关接口
export const userApi = {
  // 登录接口
  login(data) {
    return request.post('/user/login', data)
  },
  // 注册接口
  register(data) {
    return request.post('/user/register', data)
  },
  // 获取用户信息
  getUserInfo() {
    return request.get('/user/profile')
  },
  // 上传头像
  uploadAvatar(file) {
    return request.upload('/images/upload-image', file )
  },
  // 更新用户信息
  updateUserInfo(data) {
    return request.put('/user/profile', data)
  },
  // 获取用户发布过的信息
  getUserPostList(params) {
    return request.get('user/posts', params)
  },
  // 退出登陆
  logout: () => {
    return request.post('/user/logout')
  },
}

// 信息相关接口
export const postApi = {
  // 获取信息分类
  getPostCategorys() {
    return request.get('/category/list', null, { noLoading: true })
  },
  // 发布信息
  create(data) {
    return request.post('/post/create', data)
  },
  // 修改信息
  updatePost(id, data) {
    return request.put(`/post/update/${id}`, data)
  },
  // 删除信息
  deletePost(id) {
    return request.delete(`/post/${id}`)
  },
  // 获取信息列表
  getList(params) {
    return request.get('/post/list', params)
  },
  // 记录信息点击次数
  updatePostClick(id) {
    return request.patch(`/post/click/${id}`,{},{ noLoading: true })
  },
  // 单图上传
  uploadImage(file , config) {
    return request.upload('/images/upload-image', file , config)
  },
  // 多图上传
  uploadImages(files , config) {
    return request.uploadMultiple('/images/upload-multiple', files , config)
  },
  deleteImage(url) {
    const encodedUrl = encodeURIComponent(url)
  return request.delete(`/images/delete-image/${encodedUrl}`, null)
  }
}

// 评论相关接口
export const commentApi = {
  // 发布评论
  createComent(data) {
    return request.post('/comment/create', data)
  },
  // 获取评论列表
  getList(params) {
    return request.get('/comment/list', params)
  },
  // 删除评论
  deleteComment(id) {
    return request.delete(`/comment/${id}`)
  },
}